import {AsiDialogView} from "@asi-ngtools/lib";
import {HprimFaxDto, HprimFaxMedecin} from "@resources/resources";
import {Component, Input} from "@angular/core";

@Component({
  selector: 'dialog-fax-rappel',
  templateUrl: './dialog-fax-rappel.component.html'
})
export class FaxRappelComponent extends AsiDialogView {

  @Input() dossier: HprimFaxMedecin;
  @Input() reemissionType: string;

  isSuccess: boolean;
  isError: boolean;
  isInprogress: boolean;
  isWarn: boolean;

  constructor() {
    super();
  }

  ngDoCheck() {
    this.isInprogress = (this.dossier.hprimFaxDto.etat == 'EN_COURS') || !this.dossier.hprimFaxDto.etat;
    this.isSuccess = (this.dossier.hprimFaxDto.etat == 'TERMINE') || (this.dossier.hprimFaxDto.etat == 'TERMINE_EN_COURS');
    this.isError = !(this.isSuccess || this.isInprogress);
    this.isWarn = false;
  }

  ngOnInit() {
    this.dossier.hprimFaxDto.etat = null;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/utils/dialog/dialg-fax-rappel/dialog-fax-rappel.component.ts